export const getSpCount = (spCount) => {
    return spCount !== null ? (spCount === 0 ? 0.25 : spCount) : 0;
}